module.exports = __webpack_public_path__ + "static/media/raining-money-14.024047b9.gif";